import { configureStore } from "@reduxjs/toolkit";
import signInReducer from "./slices/signinSlice";
import birthDaysReducer from "./slices/GetBirthDaysByCountrySlice";
import homeLinksReducer from "./slices/GetHomeLinksByCountrySlice";
import activeLinksCountryRoleReducer from "./slices/GetActiveLinksByCountryRoleSlice";
import linkSlice from "./slices/GetAllLinksSlice";
import levels1Slice from "./slices/GetLevels1Slice";
import levels2Slice from "./slices/GetLevels2Slice";
import linksRoleByCountryReducer from "./slices/GetLinksRoleByCountrySlice";
import activeRolesByCountryReducer from "./slices/GetActiveRolesByCountrySlice";
import updateLinkRoleReducer from "./slices/UpdateLinkRoleSlice";
import addHomeLinkReducer from "./slices/AddHomeLinkSlice";
import updateHomeLinkReducer from "./slices/UpdateHomeLinkSlice";
import deleteHomeLinkReducer from "./slices/DeleteHomeLinkSlice";
import rolesByCountryReducer from "./slices/GetRolesByCountrySlice";
import addRoleReducer from "./slices/AddRoleSlice";
import updateRoleReducer from "./slices/UpdateRoleSlice";
import activeUsersReducer from "./slices/GetActiveUsersSlice";
import grantUserRolesReducer from "./slices/GrantUserRolesSlice";
import removeUserRolesReducer from "./slices/RemoveUserRolesSlice";
import addLinkReducer from "./slices/AddLinkSlice";
import editLinkReducer from "./slices/EditLinkSlice";
import addLevel2Reducer from "./slices/AddLevel2Slice";
import editLevel2Reducer from "./slices/EditLevel2Slice";

export const store = configureStore({
  reducer: {
    signIn: signInReducer,
    birthDays: birthDaysReducer,
    homeLinks: homeLinksReducer,
    activeLinksCountryRole: activeLinksCountryRoleReducer,
    links: linkSlice,
    levels1: levels1Slice,
    levels2: levels2Slice,
    linksRole: linksRoleByCountryReducer,
    activeRoles: activeRolesByCountryReducer,
    updateLinkRole: updateLinkRoleReducer,
    addHomeLink: addHomeLinkReducer,
    updateHomeLink: updateHomeLinkReducer,
    deleteHomeLink: deleteHomeLinkReducer,
    rolesByCountry: rolesByCountryReducer,
    addRole: addRoleReducer,
    updateRole: updateRoleReducer,
    activeUsers: activeUsersReducer,
    grantUserRoles: grantUserRolesReducer,
    removeUserRoles: removeUserRolesReducer,
    addLink: addLinkReducer,
    editLink: editLinkReducer,
    addLevel2: addLevel2Reducer,
    editLevel2: editLevel2Reducer,
  },
});
